import { useCallback } from 'react';

import { ONBOARDING_PROVISIONING_STATE } from '@/api/Seller/getSalesLeadOnboardingStatusQuery';

import useGetSalesLeadOnboardingStatusQuery from './hooks/useGetSalesLeadOnboardingStatusQuery';
import useSalesLeadConfirmEmailCommand from './hooks/useSalesLeadConfirmEmailCommand';
import { getCurrentStepIndex } from './OnboardingSetUp.helpers';

export interface OnboardingSetUpState {
  currentStepIndex: number;
  isFailed: boolean;
  isRetrying: boolean;
  handleRetry: () => Promise<void>;
}

export function useOnboardingSetUp(): OnboardingSetUpState {
  const confirmEmail = useSalesLeadConfirmEmailCommand();
  const { status, refetch } = useGetSalesLeadOnboardingStatusQuery({
    isEnabled: !confirmEmail.isLoading && !confirmEmail.isFailed,
  });

  const { retry } = confirmEmail;
  const handleRetry = useCallback(async () => {
    await retry();
    await refetch();
  }, [retry, refetch]);

  return {
    currentStepIndex: getCurrentStepIndex(status),
    isFailed:
      !!confirmEmail.isFailed ||
      status?.provisioningState === ONBOARDING_PROVISIONING_STATE.FAILED,
    isRetrying: confirmEmail.isRetrying,
    handleRetry,
  };
}
